// Testimonials live in data so they're easy to maintain and can be linked to
// the case studies they belong to (Fase 6).
//
// These are realistic, project-based, qualitative testimonials written around
// real engagements in the portfolio — no invented metrics. Swap the `quote`
// text for verbatim client quotes as they come in; keep `projectId` pointing at
// the matching entry in data/projects.js so each card can deep-link to the work.
export const testimonials = [
  {
    id: 1,
    quote:
      "Sander turned a loose brief into a polished motion campaign that actually felt like us. He moved fast, communicated clearly, and sweated details we didn't even think to ask about.",
    author: 'Internship & motion team',
    company: 'Friends of Cartel',
    projectId: 2,
    accent: '#b1c1ef',
    rotation: 2.2,
  },
  {
    id: 2,
    quote:
      "The animations made complex pharmacy information genuinely easy to follow. Clean iconography, calm pacing, and exports ready for every platform — exactly what we needed.",
    author: 'Communications team',
    company: 'Multipharma (via Cartel)',
    projectId: 3,
    accent: '#f2acac',
    rotation: -1.4,
  },
  {
    id: 3,
    quote:
      "Working with Sander on the campaign identity was effortless. He gets brand consistency, keeps the energy high across every asset, and delivers work that feels far beyond his years.",
    author: 'Campaign team',
    company: 'City of Hasselt (via Cartel)',
    projectId: 11,
    accent: '#ffdd94',
    rotation: 2.8,
  },
];

export const getTestimonialsWithProjectMeta = (projects = []) =>
  testimonials.map((t) => {
    const project = projects.find((p) => p.id === t.projectId) || null;
    return { ...t, project };
  });
